import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '@core';
import { DigitsGroupingPipe } from '../pipes';

@Component({
  selector: 'lib-price-and-points',
  templateUrl: './price-and-points.component.html',
  styleUrl: './price-and-points.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DigitsGroupingPipe],
})
export class PriceAndPointsComponent {
  showBoth = input<boolean>(false);
  price = input<number>();
  points = input<number>();
  delimiter = input<'and' | 'or'>('and');
  highlightTotal = input<boolean>(false);

  protected readonly canRedeemPoints = inject(UserService).canRedeemPoints;
}
